import { styled, Box } from "@mui/material"

export const MetricGoalContainer = styled(Box)({
    height: "90vh",
    display: "flex",
    flexDirection: "column",
})

export const NoGroupWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
})